export const useAnimation = () => {
  const animating = ref(false)

  const runAnimation = () => {
    if (animating.value) {
      return
    }

    animating.value = true

    const timer = setTimeout(() => {
      animating.value = false
      clearTimeout(timer)
    }, 300)
  }

  return {
    animating,

    runAnimation,
  }
}
